// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

// Use named rather than default exports.
const MissingStayRequestForm = dynamic(() =>
  import('./MissingStayRequestForm').then(mod => mod.MissingStayRequestForm)
);

export const MissingStayRequestFormConfig = {
  emptyLabel: 'missingstayrequestform',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/missingstayrequestform`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MissingStayRequestFormEditable = (props: any) => (
  <EditableComponent config={MissingStayRequestFormConfig} {...props}>
    <MissingStayRequestForm {...props} />
  </EditableComponent>
);
